var helpers = require('./live_scorings/helpers');
var initLiveScoringDesktop = require('./live_scorings/desktop');
var destroyLiveScoringDesktop = require('./live_scorings/desktop').destroy;
var initLiveScoringMobile = require('./live_scorings/mobile');
var destroyLiveScoringMobile = require('./live_scorings/mobile').destroy;

var activeLayout = null;
var resizeTimer = null;

function currentLayoutKey() {
  return helpers.isMobileLayout() ? 'mobile' : 'desktop';
}

function setupLiveScoringPage() {
  var $page = $('.controller-public-hotsites-live-scorings.action-index');
  var $root = $('#live-scoring-page');

  if ($page.length === 0 || $root.length === 0) return null;

  var layout = currentLayoutKey();

  if (activeLayout === layout) {
    helpers.syncFormFieldsForLayout();
    return null;
  }

  helpers.syncScoresBetweenLayouts(layout, activeLayout);

  destroyLiveScoringDesktop();
  destroyLiveScoringMobile();

  activeLayout = layout;

  if (layout === 'mobile') {
    return initLiveScoringMobile($page, $root);
  }

  return initLiveScoringDesktop($page);
}

function teardownLiveScoringPage() {
  destroyLiveScoringDesktop();
  destroyLiveScoringMobile();
  activeLayout = null;
}

$(document).on('turbolinks:load', function () {
  if (!$('body').hasClass('controller-public-hotsites-live-scorings')) return;

  activeLayout = null;
  setupLiveScoringPage();
  helpers.syncFormFieldsForLayout();
});

$(document).on('turbolinks:before-cache', function () {
  if (!$('body').hasClass('controller-public-hotsites-live-scorings')) return;

  teardownLiveScoringPage();
});

$(document).on('submit', '#live-scoring-form', function () {
  helpers.syncFormFieldsForLayout();
});

$(window).on('resize.liveScoringLayout', function () {
  if (!$('body').hasClass('controller-public-hotsites-live-scorings')) return;

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    setupLiveScoringPage();
    helpers.syncFormFieldsForLayout();
  }, 150);
});
